/**
 * Empty-state pill for the TOC navigator's read-only detail view. With onClick
 * it becomes a shortcut into the inline editor; without one it is plain text.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - placeholder text
 * @param {() => void} [props.onClick] - opens the editor for the active node
 */
const TocEmptyChip = ({ children, onClick }) =>
  onClick ? (
    <button type="button" className="tocnav-chip tocnav-chip-empty" title="Klik om te bewerken" onClick={onClick}>
      {children}
    </button>
  ) : (
    <span className="tocnav-chip tocnav-chip-empty">{children}</span>
  );

export default TocEmptyChip;
